import React from 'react';
import "./Navbar.css";

function Navbar() {
  return (
    <div className="navbar" id="home">
     <div className='name'>
         <p>ROBIN RAJADURAI J</p>
     </div>
     <div className='links'>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
     </div>
    </div>
  )
}

export default Navbar;